module.exports = __webpack_public_path__ + "static/media/haze.49e141fe.svg";